import React from 'react'
import { motion } from 'framer-motion'
import { brandCSS } from '../../brand'
import { NOTFOUND_CSS } from './notfound.css.js'

const item = (delay) => ({
  initial:    { opacity: 0, y: 20 },
  animate:    { opacity: 1, y: 0 },
  transition: { duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] },
})

const base = (window.wpData?.siteUrl ?? '').replace(/\/$/, '')

export default function NotFound() {
  return (
    <>
      <style>{brandCSS + NOTFOUND_CSS}</style>
      <div className="nf-page">
        <div className="nf-inner">

          <motion.div className="nf-code" {...item(0)}>404</motion.div>

          <motion.div className="nf-divider" {...item(0.1)}>
            <div className="nf-divider-line" />
            <div className="nf-divider-diamond" />
            <div className="nf-divider-line" />
          </motion.div>

          <motion.span className="nf-eyebrow" {...item(0.15)}>
            Page Not Found
          </motion.span>

          <motion.h1 className="nf-title" {...item(0.22)}>
            This voyage has no destination
          </motion.h1>

          <motion.p className="nf-desc" {...item(0.3)}>
            The page you're looking for may have been moved, renamed, or no longer exists.
            Let us guide you back to calmer waters.
          </motion.p>

          <motion.div className="nf-actions" {...item(0.38)}>
            <a href={base || '/'} className="ljn-btn-primary">
              Back to Home
            </a>
            <a href={`${base}/cruises`} className="ljn-btn-secondary">
              View Our Cruises
            </a>
          </motion.div>

        </div>
      </div>
    </>
  )
}
